import React, { useContext, useEffect } from 'react'
import { useLazyQuery, gql, NetworkStatus } from '@apollo/client'
import { Paper, Typography } from '@material-ui/core'
import ChartColumn from '../../../../components/charts/ChartColumn'
import ChartColumnSkeleton from '../../../../components/skeletons/ChartColumnSkeleton'
import { ChartColumnThemes } from '../../../../components/charts/types/ChartColumn'
import { PharmaciesFiltersContext } from '../../../../context/PharmaciesFiltersContext'
import { formatNumber, formatCurrency } from '../../../../utils/Helpers'
import { STATUS_DELIVERED } from '../../../../types/Order'
// import { GET_ORDER_FINISHED } from '../../../../queries/pharmacies'

const GET_ORDER_FINISHED = gql`
  query OrderFinished($filters: JSON) {
    ordersAggs(
      filters: $filters,
      size: 0,
      query: {
        bool: {
          filter: [
            {
              term: {
                status_translate_keyword: {
                  value: "${STATUS_DELIVERED}"
                }
              }
            }
          ]
        }
      },
      aggs: {
        pharmacies: {
          terms: {
            field: "pharmacy_name.keyword",
            size: 10,
            order: {
              totals: "desc"
            }
          },
          aggs: {
            totals: {
              sum: {
                field: "total"
              }
            }
          }
        }
      }
    ) {
      aggregations
    }
  }
`

interface Bucket {
  key: string
  doc_count: number,
  totals: {
    value: number
  }
}
const TotalOrdersFinishedPharmacies = (): JSX.Element => {
  const { filters } = useContext(PharmaciesFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_ORDER_FINISHED, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData({
      variables: { filters }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <ChartColumnSkeleton />
  if (loading || !data) return <ChartColumnSkeleton />
  if (error) return <p>Error :(</p>
  if (!data.ordersAggs.aggregations) return <p>No data found</p>

  const { buckets } = data.ordersAggs.aggregations.pharmacies
  const categories: Array<string> = []
  const seriesData: Array<number> = []
  buckets.map((bucket: Bucket) => {
    categories.push(bucket.key)
    return seriesData.push(bucket.totals.value)
  })

  const options = {
    chart: {
      id: 'total-orders-finished'
    },
    xaxis: {
      categories
    },
    grid: {
      show: false
    },
    plotOptions: {
      bar: {
        dataLabels: {
          position: 'top'
        }
      }
    },
    dataLabels: {
      offsetY: -20,
      formatter: (val: number) => {
        return formatNumber(val, 2, true)
      },
      style: {
        colors: ['#304758']
      }
    },
    yaxis: {
      labels: {
        formatter: (value: number) => {
          return formatCurrency(value, 2)
        }
      }
    }
  }
  const series = [{
    name: 'Pedidos finalizados',
    data: seriesData
  }]

  if (!data) return <></>

  return <Paper elevation={2}>
    <Typography
      paragraph
      style={{ paddingLeft: '20px', paddingTop: '20px' }}
    >
      TOP 10 farmácias x Total de pedidos entregues (R$)
      {/* ({formatDateCard(filters.orderCreatedAt?.initialDate, filters.orderCreatedAt?.finalDate)}) */}
    </Typography>
    <ChartColumn options={options} series={series} theme={ChartColumnThemes.blue} height={280} />
  </Paper>
}

export default TotalOrdersFinishedPharmacies
